export default "__VITE_ASSET__BAlcyRdD__"